import React, { useRef } from 'react';
import { Input, Label, FormGroup, Form, Alert, Button, ButtonGroup, InputGroup } from 'reactstrap';
import { Menu, MenuItem, IconButton, Popover } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ClearIcon from '@mui/icons-material/DeleteForeverOutlined';

const customOptions = [
    {
        Name: "@model.BPNAME",
        Description: {
            en: "BP Name"
        }
    },
    {
        Name: "@model.BPNUMBER",
        Description: {
            en: "BP Number"
        }
    },
    {
        Name: "@model.BPCNUMBER",
        Description: {
            en: "BPC Number"
        }
    },
    {
        Name: "@model.BPSNUMBER",
        Description: {
            en: "BPS Number"
        }
    },
    {
        Name: "@model.@Company",
        Description: {
            en: "Company"
        }
    },
    {
        Name: "@model.@Currency",
        Description: {
            en: "Currency"
        }
    },
    {
        Name: "@model.Description",
        Description: {
            en: "Description"
        }
    },
    {
        Name: "@model.DocumentID",
        Description: {
            en: "Document Ref"
        }
    },
    {
        Name: "@model.DocumentType",
        Description: {
            en: "Document Type"
        }
    },
    {
        Name: "@model.OrderRef",
        Description: {
            en: "Order Ref"
        }
    },
    {
        Name: "@model.Pages",
        Description: {
            en: "Pages"
        }
    },
    {
        Name: "@model.@TransactionDate",
        Description: {
            en: "Transaction Date"
        }
    },
    {
        Name: "@model.@TransactionNumber",
        Description: {
            en: "Transaction Number"
        }
    },
    {
        Name: "@model.@TransactionType",
        Description: {
            en: "Transaction Type"
        }
    },
    {
        Name: "@model.@TransactionValue",
        Description: {
            en: "Transaction Value"
        }
    },
    {
        Name: "@model.UserName",
        Description: {
            en: "User Name"
        }
    }
];

export const QuillParameterUrlPopover = props => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [inputCursor, setInputCursorLocation] = React.useState(0);
    const [imageData, setImageData] = React.useState("");
    const open = Boolean(anchorEl);
    const [paramURL, setParamURL] = React.useState("");
    const [paramURLName, setParamURLName] = React.useState("");

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuItemSelect = (value) => {
        let url = paramURL.substr(0, inputCursor) + value + paramURL.substr(inputCursor)
        setParamURL(url);
        handleClose();
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleURLClearButton = () => {
        setParamURL("");
    }

    const handleTextClearButton = () => {
        setParamURLName("");
    }

    const onFileSelectChange = (files) => {
        var reader = new FileReader();
        reader.readAsDataURL(files[0]);
        reader.onload = function () {
            setImageData(reader.result);
        };
        reader.onerror = function (error) {
            console.error(error);
        };
    }

    const saveParamURL = () => {
        let url = "";

        if (imageData)
            url = "<a href='" + paramURL + "'>" + paramURLName + "<img src='" + imageData + "' alt='" + paramURLName + "' />" + "<a>";
        else
            url = "<a href='" + paramURL + "'>" + paramURLName + "</a>";

        props.handlePopoverConfirm(url);
    }

    return (
        <Popover
            id={props.popoverURLAncor && 'simple-popover'}
            open={props.popoverURLAncor}
            anchorEl={props.popoverURLAncor}
            onClose={props.handlePopoverURLClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <div style={{ padding: 20 }}>
                <p style={{ fontSize: '.9rem' }}>Enter URL Below</p>
                <InputGroup>
                    <Input
                        id="html"
                        type="text"
                        value={paramURL}
                        onChange={(e) => setParamURL(e.target.value)}
                        onMouseUp={(e) => setInputCursorLocation(e.target.selectionStart)}
                        onKeyUp={(e) => setInputCursorLocation(e.target.selectionStart)}
                    />
                    <IconButton
                        color="#3c424f"
                        aria-controls="menu"
                        aria-haspopup="true"
                        size="small"
                        onClick={handleClick}
                    >
                        <MoreVertIcon />
                    </IconButton>
                    <Menu
                        id="menu"
                        anchorEl={anchorEl}
                        open={open}
                        keepMounted
                        onClose={handleClose}
                        PaperProps={{
                            style: {
                                maxHeight: 48 * 4.5,
                                width: 200,
                            },
                        }}
                    >
                        {customOptions && customOptions.map(option => (
                            <MenuItem key={option.Name} onClick={() => handleMenuItemSelect(option.Name)}>
                                {option.Description['en']}
                            </MenuItem>
                        ))}

                        {props.options && props.options.map(option => (
                            <MenuItem key={option.Name} onClick={() => handleMenuItemSelect('@model.DocumentData.' + option.Name)}>
                                {option.Description['en']}
                            </MenuItem>
                        ))}
                    </Menu>
                    <IconButton
                        color="#3c424f"
                        aria-controls="menu"
                        aria-haspopup="true"
                        size="small"
                        onClick={handleURLClearButton}
                    >
                        <ClearIcon />
                    </IconButton>
                </InputGroup>
                <p style={{ fontSize: '.9rem' }}>Enter Text Below</p>
                <InputGroup>
                    <Input id="html" type="text" value={paramURLName} onChange={(e) => setParamURLName(e.target.value)} />
                    <IconButton
                        color="#3c424f"
                        aria-controls="menu"
                        aria-haspopup="true"
                        size="small"
                        onClick={handleTextClearButton}
                    >
                        <ClearIcon />
                    </IconButton>
                </InputGroup>
                <p style={{ fontSize: '.9rem' }}>Select Image Below</p>
                <InputGroup>
                    <input
                        id="fileId"
                        type="file"
                        multiple={false}
                        accept="image/png, image/jpeg"
                        onChange={e => {
                            onFileSelectChange([...e.target.files]);
                        }}
                    />
                </InputGroup>
                <ButtonGroup style={{ marginTop: 20 }}>
                    <Button color="primary" onClick={() => saveParamURL()}>
                        Add
                    </Button>
                    <Button color="danger" onClick={props.handlePopoverURLClose}>
                        Close
                    </Button>
                </ButtonGroup>
            </div>
        </Popover>
    )
}